module.exports = __webpack_public_path__ + "img/3-digit-code.636c2d27.svg";